import { joinStringsAndValues as r, isStrTagged as g } from "./str-tag.js"; /**
                                                                            * @license
                                                                            * Copyright 2021 Google LLC
                                                                            * SPDX-License-Identifier: BSD-3-Clause
                                                                            */
var n = function n(s) {
  return g(s) ? r(s.strings, s.values) : s;
};
export { n as defaultMsg };